// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import RoutesComponent from '../src/routes/routesComponent.js';
import './App.css';
import Footer from './NewUPT/shared/Footer.jsx';
import { Helmet } from 'react-helmet';

function App() {
  return (
    <>
      <Helmet>
        <title>New 'U' Physical Therapy</title>
        <link
          rel="icon"
          type="image/png"
          href="https://www.newuphysicaltherapy.com/images/header/newuphysicaltherapylogo.png?v=3"
        />
      </Helmet>

      <Router>
        <div className="App">
          {/* All routing (with Layout) */}
          <RoutesComponent />

          {/* Stays at the bottom */}
          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;
